import { createSelector } from 'reselect';
import productVariantsByIdSelector from './productVariantsById';

export default createSelector(productVariantsByIdSelector, (variants) => Object.values(variants));
